import {Link, Redirect, Route, useHistory,  useLocation} from 'react-router-dom';
import PropTypes from "prop-types";
import logo from "../../assets/images/logo.png";
import {useKeycloak} from "@react-keycloak/web";
import logOut from "../../assets/images/log_out.svg";

const InternalStudent = ({component: Component, ...rest}) => {
    const {keycloak, initialized} = useKeycloak();
    const history = useHistory();
    const path = history.location.pathname;
    let redirectRoute = null;
    if (keycloak && keycloak.authenticated) {
        const isStudent = keycloak.realmAccess.roles.includes('student')
        if (!isStudent) {
            redirectRoute = "/student/complete-profile";
        }
    } else {
        redirectRoute = "/login";
    }

    return (
        <Route {...rest} render={matchProps => (
            redirectRoute ?
                <Redirect push to={redirectRoute}/> :
                <div className={"layout InternalLayout"}>
                    <img src={logo} className={"p-3 absolute buddingAILogo cursor-pointer"} alt="budding-ai-logo"
                         onClick={() => history.push("/")} draggable={false}/>
                    <button
                        className="absolute px-4 py-2 cursor-pointer top-0 right-0 rounded m-4 z-50"
                        onClick={() => keycloak.logout()}>
                        <div className="flex justify-between items-center gap-3">
                            <img src={logOut} className="h-4 w-4" alt="Logout" draggable={false}/>
                            <span className="text-black text-base">Logout</span>
                        </div>
                    </button>
                    <div className="content">
          <Component {...matchProps} />
        </div>

        {keycloak?.idTokenParsed?.sid &&
          !path.includes("edit-student-profile") && (
            <>
              <span className="lg:fixed bottom-0 right-0 mr-5 mb-5 hidden lg:block">
                <Link
                  to={`/student/${keycloak.idTokenParsed.sid}/edit-student-profile`}
                >
                  <span className="ml-2 border-b border-b-black">
                    Edit profile now
                  </span>
                </Link>
              </span>

              <span className="flex justify-end mr-5 mb-5 lg:hidden">
                <Link
                  to={`/student/${keycloak.idTokenParsed.sid}/edit-student-profile`}
                >
                  <span className="ml-2 border-b border-b-black">
                    Edit profile now
                  </span>
                </Link>
              </span>
            </>
          )}
      </div>
        )}/>
    )
};

export default InternalStudent;

InternalStudent.propTypes = {
    component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
}
